'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SurflineFooter = require('./SurflineFooter');

var _SurflineFooter2 = _interopRequireDefault(_SurflineFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SurflineFooter2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflineFooter/index.js
// module id = 331
// module chunks = 0